import { Injectable, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";



@Injectable()
export class DomainService {
    constructor(private router: Router) { }

    validateLocalRoute(url: string): boolean {
        if (url === "/") {
            this.router.navigate(["map"]);
            return false;
        }
        return true;
    }

    validateRoute(url: string, target: string): boolean {
        let subdomain = window.location.host.split(".")[0];

        // redirect empty urls to relevant base view
        if (url === "/") {
            this.router.navigate(subdomain === "map" ? ["map"] : ["programs"]);
            return false;
        }

        if (subdomain === target) { return true; }

        // TODO: set up test & dev server certs
        window.location.href = "https://" + target + "." + environment.hostbase + url;
        return false;
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/guards/domain.service.ts